/**
 * Converts an attribute key to an object string representation.
 *
 * This function takes a string key, removes the "attributes_" prefix if present,
 * and returns a string formatted as `Attributes['key']`.
 *
 * @param key - The attribute key to convert.
 * @returns The converted attribute key as an object string.
 */
export function convertAttributeKeyToObjectString(key: string): string {
  if (key.includes('Attributes[')) {
    return key;
  }

  return `Attributes['${key.replace(/^attributes_/, '')}']`;
}

/**
 * Extracts the attribute key from a given string.
 *
 * This function processes a string that represents an attribute key and returns
 * the cleaned key by removing specific patterns. If the key contains "Attributes['",
 * it will remove this pattern along with the closing "']". If the key contains
 * "attributes_", it will remove this prefix.
 *
 * @param key - The attribute key string to be processed.
 * @returns The cleaned attribute key.
 */
export function getAttributeKey(key: string) {
  return key.includes('Attributes[')
    ? key.replace("Attributes['", '').replace("']", '')
    : key.replace('attributes_', '');
}

export const getFilterValueAsNumberIfSuch = (value: string | number) => {
  if (/^\d+$/.test(value as string)) {
    return parseInt(value as string, 10);
  }

  return value;
};
